'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Intent = function (_React$Component) {
  _inherits(Intent, _React$Component);

  function Intent() {
    _classCallCheck(this, Intent);

    return _possibleConstructorReturn(this, (Intent.__proto__ || Object.getPrototypeOf(Intent)).apply(this, arguments));
  }

  _createClass(Intent, [{
    key: 'render',
    value: function render() {
      var orgClass = 'generic-intent__intent';
      var Component = _react2.default.cloneElement(this.props.children, {
        handleChange: this.props.handleChange
      });

      return _react2.default.createElement(
        'div',
        { className: orgClass + ' col-xs-12 col-md-6' },
        Component
      );
    }
  }]);

  return Intent;
}(_react2.default.Component);

exports.default = Intent;


Intent.propTypes = {
  children: _propTypes2.default.any.isRequired,
  handleChange: _propTypes2.default.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/generic-intent/jsx/Intent.js
// module id = 679
// module chunks = 4